export enum Apps {
  Unknown = 0,
  TPM = 1,
  POS = 2,
  Donation = 3,
  Lister = 4,
  AdminPortal = 5,
  CompanyPortal = 6,
  Inventory = 7,
  Consignment = 8,
}
export enum UserType {
  Unknown = 0,
  AppUser,
  ServiceUser,
  ApiUser,
}

// Company integration credentials (values MUST match CompanyMgmt.API enums).
export enum IntegrationSystem {
  Unknown = 0,
  QuickBooks = 1,
  Shopify = 2,
  Stripe = 3,
  Zoho = 4,
  Metabase = 5,
  RcsAero = 6,
  Custom = 7,
}

// Only the systems exposed in the UI for now. Add entries here to enable more.
export const IntegrationSystemLabels: Partial<Record<IntegrationSystem, string>> = {
  [IntegrationSystem.RcsAero]: 'RcsAero',
};

export enum IntegrationCredentialType {
  Unknown = 0,
  ApiKey = 1,
  UsernamePassword = 2,
  OAuthToken = 3,
}

export enum IntegrationCredentialStatus {
  Unknown = 0,
  Draft = 1,
  Active = 2,
  Inactive = 3,
}
export enum SubscriptionPlanType {
  Unknown = 0,
  Self = 1,
  SalesAssisted = 2,
}

export enum SubscriptionStatus {
  Unknown = 0,
  Active = 1,
  Trial = 2,
  PastDue = 3,
  Suspended = 4,
  Expired = 5,
  Cancelled = 6,
}

export enum SubscriptionChangeTiming {
  Immediate = 1,
  EndOfCycle = 2,
}

export enum SubscriptionChangeRequestType {
  Unknown = 0,
  ChangePlan = 1,
  ManageAddOns = 2,
  CancelSubscription = 3,
  ChangeBillingCycle = 4,
}

export enum SubscriptionChangeRequestStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  CancelledByCustomer = 3,
  Processing = 4,
  Completed = 5,
  Failed = 6,
}

export enum LicenseAttributeType {
  Unknown = 0,
  BasePrice = 1,
  NoOfLicenses = 2,
  AdditionalPricePerLicense = 3,
  AllowedAdditionalLicenses = 4,
  NoOfAdditionalLicenses = 5,
}

export enum Status {
  Unknown = 0,
  Draft = 1,
  Active = 2,
  Inactive = 3,
}

/**
 * Status filter values used for filtering lists by status
 */
export enum StatusFilter {
  All = 'all',
  Active = 'active',
  Inactive = 'inactive',
}

export enum UserStatus {
  Unknown,
  Active,
  Inactive,
  Pending,
}
export enum UserInvitationStatus {
  Unknown = 0,
  Accepted = 1,
  InvitationSent = 2,
  Expired = 3,
  NotInvited = 4,
}
export enum CallbackRequestStatus {
  Unknown = 0,
  Pending = 1,
  Completed = 2,
  Cancelled = 3,
}
export enum WarehouseLocationFormatType {
  Unknown = 0,
  ARSB = 1,
  Standard = 2,
}
export enum AddressType {
  Unknown = 0,
  Home,
  Office,
  Billing,
  Shipping,
  Postal,
}

export enum BillingCycle {
  Monthly = 1,
  Yearly_PaidMonthly = 2,
  Yearly_PaidYearly = 3,
}

export enum DiscountType {
  Unknown = 0,
  NoDiscount = 1,
  Percentage = 2,
  Amount = 3,
}

export const DiscountTypeLabels: Record<DiscountType, string> = {
  [DiscountType.Unknown]: 'Unknown',
  [DiscountType.NoDiscount]: 'No Discount',
  [DiscountType.Percentage]: 'Percentage',
  [DiscountType.Amount]: 'Flat Amount',
};

export enum CompanyDiscountType {
  Unknown = 0,
  Percentage = 1,
  Amount = 2,
}

export const CompanyDiscountTypeLabels: Record<CompanyDiscountType, string> = {
  [CompanyDiscountType.Unknown]: 'Unknown',
  [CompanyDiscountType.Percentage]: 'Percentage',
  [CompanyDiscountType.Amount]: 'Flat Amount',
};

export enum CompanyDiscountStatus {
  Unknown = 0,
  Active = 1,
  Inactive = 2,
  Expired = 3,
}

export const CompanyDiscountStatusLabels: Record<CompanyDiscountStatus, string> = {
  [CompanyDiscountStatus.Unknown]: 'Unknown',
  [CompanyDiscountStatus.Active]: 'Active',
  [CompanyDiscountStatus.Inactive]: 'Inactive',
  [CompanyDiscountStatus.Expired]: 'Expired',
};

export enum ServiceCategory {
  Unknown = 0,
  AppAccess = 1,
  AddOn = 2,
}

export const ServiceCategoryLabels: Record<ServiceCategory, string> = {
  [ServiceCategory.Unknown]: 'Unknown',
  [ServiceCategory.AppAccess]: 'App Access',
  [ServiceCategory.AddOn]: 'Add-On',
};

export enum ChargeType {
  Unknown = 0,
  Flat = 1,
  PerSeat = 2,
  PerTransaction = 3,
  PercentageOfRevenue = 4,
  PerStore = 5,
}

export const ChargeTypeLabels: Record<ChargeType, string> = {
  [ChargeType.Unknown]: 'Unknown',
  [ChargeType.Flat]: 'Flat Fee',
  [ChargeType.PerSeat]: 'Per Seat',
  [ChargeType.PerTransaction]: 'Per Transaction',
  [ChargeType.PercentageOfRevenue]: '% of Revenue',
  [ChargeType.PerStore]: 'Per Store',
};

export enum ChargeFrequency {
  Unknown = 0,
  PerBillingCycle = 1,
  OneTime = 2,
}

export const ChargeFrequencyLabels: Record<ChargeFrequency, string> = {
  [ChargeFrequency.Unknown]: 'Unknown',
  [ChargeFrequency.PerBillingCycle]: 'Per Billing Cycle',
  [ChargeFrequency.OneTime]: 'One-Time',
};

export enum ValueDataType {
  Unknown = 0,
  Money = 1,
  Percentage = 2,
}

export const ValueDataTypeLabels: Record<ValueDataType, string> = {
  [ValueDataType.Unknown]: 'Unknown',
  [ValueDataType.Money]: 'Money',
  [ValueDataType.Percentage]: 'Percentage',
};

// pagination.constants.ts
export const PageSizes: number[] = [15, 30, 45];

export enum GoalType {
  Unknown = 0,
  UserGoals = 1,
  StoreGoals = 2,
}

export enum TPMUserModules {
  Admin = 3,
  Production = 2,
}
export enum AppPlatform {
  Unknown = 0,
  Android = 1,
  Windows = 2,
}

export enum AppEnvironment {
  Unknown = 0,
  Development = 1,
  Testing = 2,
  Staging = 3,
  PreProduction = 4,
  Production = 5,
}

export enum ProductionScheduleType {
  Unknown = 0,
  WeeklySchedule = 1,
  DateSpecific = 2,
}

export enum MobileApp {
  Unknown = 0,
  TpmOffline = 1,
  PosOnline = 2,
}

export enum PrinterType {
  Unknown = 0,
  ZebraLabel = 1,
  ZebraTag = 2,
  ZebraBoth = 3,
}

export enum LabelImageType {
  FrontImage = 0,
  BackImage = 1,
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export enum MeasurementType {
  Unknown = 0,
  Unit = 1,
  Weight = 2,
  Volume = 3,
  Length = 4,
  Area = 5,
}

export enum LabelEntityType {
  Unknown = 0,
  Product = 1,
  Container = 2,
}
export enum PipelineStatus {
  Unknown = 0,
  InProgress = 1,
  Completed = 2,
  Failed = 3,
  PendingReview = 4,
}

export enum PipelineHealthStatus {
  Unknown = 0,
  Healthy = 1,
  Degraded = 2,
  Critical = 3,
}
